<!--
 * @Author: songyzh
 * @Date: 2020-07-27 21:51:29
 * @LastEditors: songyzh
 * @LastEditTime: 2020-07-31 09:11:18
-->
<template>
  <div id="app" class="w-full h-full">
   <router-view/>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
</style>
